import { render, staticRenderFns } from "./ViewUrlPageTable.vue?vue&type=template&id=0e5e22ab"
import script from "./ViewUrlPageTable.vue?vue&type=script&lang=js"
export * from "./ViewUrlPageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports